module.exports = __webpack_public_path__ + "static/media/results-image1.4ff57df6.png";